type BtnSubmitLoaderProp = {
    loading: boolean,
    submitText?: string
}
export const BtnSubmitLoader: React.FC<BtnSubmitLoaderProp> = (props) => {
    return <>
     <button type='submit' className='btn btn-primary me-10' disabled={props.loading}>
                {!props.loading && props.submitText ? props.submitText : 'Save Changes'}
                {props.loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                )}
            </button>
        

    </>
}